import { Result, TrimValidationFields, backendApi } from "./backendApi";

export interface TemplateTextModel {
  dxfBlockName?: string;
  crsName?: string;
  crsInfo?: string;
  defaultTemplateTextTypeId?: number;
}

class UpdateDefaultTemplateTextRequest {
  name?: string;
  defaultTemplateTextTypeId?: number;
  defaultTemplateText?: TemplateTextModel;
}

class CreateDefaultTemplateTextRequest {
  defaultTemplateText?: TemplateTextModel;
}

class GetDefaultTemplateTextRequest {}

class GetDefaultTemplateTextResponse {
  defaultTemplateTexts?: TemplateTextModel[];
}

class DeleteDefaultTemplateTextRequest {
  dxfBlockName?: string;
  defaultTemplateTextTypeId?: number;
}

export const templateTextApi = {
  async getTemplateTexts(): Promise<Result<TemplateTextModel[]>> {
    let response =
      await backendApi.sendAndGetResponseAsync<GetDefaultTemplateTextResponse>(
        "GetDefaultTemplateTexts",
        new GetDefaultTemplateTextRequest(),
      );

    if (response.ok) {
      return { ok: true, value: response.value.defaultTemplateTexts ?? [] };
    }

    return response;
  },

  async updateTemplateText(
    templateText: TemplateTextModel,
    initialBlockName: string | undefined,
    initialTemplateTextTypeId: number | undefined,
  ): Promise<Result<any>> {
    let response = await backendApi.sendAsync("UpdateDefaultTemplateText", {
      dxfBlockName: initialBlockName,
      defaultTemplateTextTypeId: initialTemplateTextTypeId,
      defaultTemplateText: templateText,
    } as UpdateDefaultTemplateTextRequest);

    if (response.ok) {
      return { ok: true, value: true };
    }

    TrimValidationFields(response.problem, "DefaultTemplateText");

    return response;
  },

  async createTemplateText(
    defaultTemplateText: TemplateTextModel,
  ): Promise<Result<any>> {
    let response = await backendApi.sendAsync("CreateDefaultTemplateText", {
      defaultTemplateTextModel: defaultTemplateText,
    } as CreateDefaultTemplateTextRequest);

    if (response.ok) {
      return { ok: true, value: true };
    }

    TrimValidationFields(response.problem, "defaultTemplateTextModel");

    return response;
  },

  async deleteTemplateText(
    dxfBlockName?: string,
    defaultTemplateTextTypeid?: number,
  ): Promise<Result<any>> {
    let response = await backendApi.sendAsync("DeleteDefaultTemplateText", {
      dxfBlockName: dxfBlockName,
      defaultTemplateTextTypeId: defaultTemplateTextTypeid,
    } as DeleteDefaultTemplateTextRequest);

    if (response.ok) {
      return { ok: true, value: true };
    }

    return response;
  },
};
